import wrapWithProvider from "./wrap-with-provider";
import { loadAdsenseScript } from "./src/utils/adsense";

const googleAnalyticsId = process.env.GATSBY_GOOGLE_ANALYTICS_ID ?? "";

export const onClientEntry = () => {
  loadAdsenseScript();
};

export const onRouteUpdate = ({ prevLocation, location }) => {
  window.PREVIOUS_PATH = prevLocation ? prevLocation.pathname : null;

  loadAdsenseScript();

  if (googleAnalyticsId && typeof window.gtag === "function") {
    window.gtag("config", googleAnalyticsId, {
      page_path: location.pathname,
    });
  }
};

export const wrapRootElement = wrapWithProvider;
